// Index 0 = account, indices 1–MAX_PEERS = peers. Array length must be MAX_PEERS + 1.
export const CHART_COLORS = [
  "oklch(0.55 0.18 250)", // Blue (Account — index 0)
  "oklch(0.55 0.15 145)", // Green (Peer 1 — index 1)
  "oklch(0.65 0.14 85)", // Gold (Peer 2 — index 2)
  "oklch(0.50 0.15 310)", // Violet (Peer 3 — index 3)
  "oklch(0.55 0.12 195)", // Teal (Peer 4 — index 4)
  "oklch(0.55 0.12 0)", // Pink (Peer 5 — index 5)
];
